import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SystemMessageHistory } from 'src/api'
import { useApiInstance } from './useApiInstance'

type ToggleVisibilityVariables = {
  id: number
  isHidden: boolean
}

interface RequestParams {
  options?: Omit<
    UseMutationOptions<SystemMessageHistory, Error, ToggleVisibilityVariables>,
    'mutationKey' | 'mutationFn'
  >
}

export const useToggleSystemMessageVisibility = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()
  const queryClient = useQueryClient()

  return useMutation<SystemMessageHistory, Error, ToggleVisibilityVariables>(
    [Entities.SystemMessage, 'visibility'],
    async ({ id, isHidden }) => {
      const { data } = await api.v1AdminSystemMessagesHistorySystemMessageHistoryIdVisibilityPut(id, { isHidden })
      return data as SystemMessageHistory
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([Entities.SystemMessage])
      },
      ...options,
    },
  )
}
